import { __decorate } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { AngularSvgIconModule } from 'angular-svg-icon';

let UiCPrizeDrawMessageComponent = class UiCPrizeDrawMessageComponent {
    constructor(modalController) {
        this.modalController = modalController;
        if (this.image && this.image !== '') {
            this.svg = null;
        }
        else if (this.svg && this.svg !== '') {
            this.image = null;
        }
        else {
            this.svg = null;
            this.image = null;
        }
        this.cancelText = this.isEmpty(this.cancelText) ? this.cancelText : 'Cancelar';
        this.tryAgainText = this.isEmpty(this.tryAgainText) ? this.tryAgainText : 'Tentar novamente';
        this.btnText = this.isEmpty(this.btnText) ? this.btnText : this.confirmation ? 'Confirmar' : 'Fechar';
    }
    isEmpty(str) {
        if (str == null || str === undefined) {
            return true;
        }
        if (str === '') {
            return true;
        }
        if (String(str).length === 0) {
            return true;
        }
        return false;
    }
    dismissMethod(event) {
        this.modalController.dismiss(event);
    }
};
UiCPrizeDrawMessageComponent.ctorParameters = () => [
    { type: ModalController }
];
__decorate([
    Input()
], UiCPrizeDrawMessageComponent.prototype, "image", void 0);
__decorate([
    Input()
], UiCPrizeDrawMessageComponent.prototype, "svg", void 0);
__decorate([
    Input()
], UiCPrizeDrawMessageComponent.prototype, "status", void 0);
__decorate([
    Input()
], UiCPrizeDrawMessageComponent.prototype, "message", void 0);
__decorate([
    Input()
], UiCPrizeDrawMessageComponent.prototype, "title", void 0);
__decorate([
    Input()
], UiCPrizeDrawMessageComponent.prototype, "confirmation", void 0);
__decorate([
    Input()
], UiCPrizeDrawMessageComponent.prototype, "tryAgain", void 0);
__decorate([
    Input()
], UiCPrizeDrawMessageComponent.prototype, "btnText", void 0);
__decorate([
    Input()
], UiCPrizeDrawMessageComponent.prototype, "cancelText", void 0);
__decorate([
    Input()
], UiCPrizeDrawMessageComponent.prototype, "tryAgainText", void 0);
UiCPrizeDrawMessageComponent = __decorate([
    Component({
        selector: 'ui-c-prizedraw-message',
        template: "<div class=\"prizedraw-message-component\">\n  <div class=\"inner-content\">\n    <ion-grid>\n      <ion-row class=\"ion-justify-content-center ion-text-center prizedraw-message-icon\" *ngIf=\"svg || image\">\n        <ion-col size=\"10\" id=\"col-modal-image\" class=\"ion-padding\">\n          <svg-icon *ngIf=\"svg\" [class]=\"'ion-img ' + status\" [stretch]=\"false\" [src]=\"svg\"> </svg-icon>\n          <img *ngIf=\"image\" [class]=\"'ion-img ' + status\" [src]=\"image\" />\n        </ion-col>\n      </ion-row>\n\n      <ion-row class=\"prizedraw-message-text justify-content-center align-items-center mt-2\">\n        <ion-col size=\"12\" class=\"title-message\">\n          <h2 [class]=\"'title ' + status + ' text-center mt-0 px-2'\">\n            {{ title }}\n          </h2>\n          <hr class=\"line\" />\n        </ion-col>\n        <ion-col size=\"12\" class=\"message\">\n          <ion-text class=\"ion-text\">\n            <p [class]=\"'message ' + status + ' text-center m-0 px-2'\">{{ message }}</p>\n          </ion-text>\n        </ion-col>\n      </ion-row>\n    </ion-grid>\n    <div class=\"group-buttons prizedraw-message-buttons mt-2\">\n      <ng-container *ngIf=\"!confirmation\">\n        <ion-button class=\"btn-confirm text-align-center\" expand=\"block\" (click)=\"dismissMethod('confirm')\" mode=\"md\">\n          {{ btnText }}\n        </ion-button>\n      </ng-container>\n      <ng-container *ngIf=\"tryAgain\">\n        <ion-button class=\"btn-confirm text-align-center\" expand=\"block\" (click)=\"dismissMethod('try-again')\" mode=\"md\">\n          {{ tryAgainText }}\n        </ion-button>\n      </ng-container>\n      <ng-container *ngIf=\"confirmation\">\n        <ion-button class=\"btn-confirm text-align-center\" expand=\"block\" (click)=\"dismissMethod('confirm')\" mode=\"md\">\n          {{ btnText }}\n        </ion-button>\n        <ion-button class=\"btn-cancel text-align-center\" expand=\"block\" (click)=\"dismissMethod('cancel')\" mode=\"md\">\n          {{ cancelText }}\n        </ion-button>\n      </ng-container>\n    </div>\n  </div>\n</div>\n",
        styles: [""]
    })
], UiCPrizeDrawMessageComponent);

let UiCPrizeDrawMessageModule = class UiCPrizeDrawMessageModule {
};
UiCPrizeDrawMessageModule = __decorate([
    NgModule({
        declarations: [UiCPrizeDrawMessageComponent],
        imports: [IonicModule, CommonModule, UiCButtonModule, AngularSvgIconModule.forRoot(), UiBsTranslateModule],
        exports: [UiCPrizeDrawMessageComponent],
    })
], UiCPrizeDrawMessageModule);

/*
 * Public API Surface of ui-c-prizedraw-message
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCPrizeDrawMessageComponent, UiCPrizeDrawMessageModule };
//# sourceMappingURL=wlp-ui-c-prizedraw-message.js.map
